<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div>
      <vx-card>
        <div>
          <vs-table
            :max-items="descriptionItems[0]"
            pagination
            :data="vendors"
            description
            search
            @selected="viewVendor"
            :description-items="descriptionItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("setup.label.VendorManagement") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create Vendor Management' })"
                  size="small"
                  >{{ $t("setup.label.CreateVendor") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.Code") }}</vs-th>
              <vs-th>{{ $t("setup.label.Name") }}</vs-th>
              <vs-th>{{ $t("setup.label.Email") }}</vs-th>
              <vs-th>{{ $t("setup.label.ContactName") }}</vs-th>
              <vs-th>{{ $t("setup.label.Mobile") }}</vs-th>
              <vs-th>{{ $t("setup.label.Landline") }}</vs-th>
              <vs-th>{{ $t("setup.label.Address") }}</vs-th>
              <vs-th>{{ $t("setup.label.Currency") }}</vs-th>
              <vs-th>{{ $t("setup.label.Country") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="vendor"
                v-for="(vendor, index) in data"
              >
                <vs-td :data="vendor.vendorCode">{{ vendor.vendorCode }}</vs-td>
                <vs-td :data="vendor.vendorName">{{ vendor.vendorName }}</vs-td>
                <vs-td :data="vendor.vendorEmailId">{{
                  vendor.vendorEmailId
                }}</vs-td>
                <vs-td :data="vendor.contactName">{{
                  vendor.contactName
                }}</vs-td>
                <vs-td :data="vendor.vendormobileNo">{{
                  vendor.vendormobileNo
                }}</vs-td>
                <vs-td :data="vendor.vendorLandlineNo">{{
                  vendor.vendorLandlineNo
                }}</vs-td>
                <vs-td :data="vendor.vendorAddress">{{
                  vendor.vendorAddress
                }}</vs-td>
                <vs-td :data="vendor.vendorCurrency">{{
                  vendor.vendorCurrency
                }}</vs-td>
                <vs-td :data="vendor.emaivendorCountryNamelid">{{
                  vendor.vendorCountryName
                }}</vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editVendor(vendor.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('setup.label.Delete')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="
                        delId = vendor.id;
                        deleteUserDataPopup = true;
                      "
                      class="icon_row"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>
    </div>
    <delete-popup
      :deletePopup="deleteUserDataPopup"
      title="Vendor Management"
      @deletePressed="deleteVendor(delId)"
      @cancelPressed="deleteUserDataPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";

export default {
  data() {
    return {
      searchOption: 0,
      loading: false,
      deleteUserDataPopup: false,
      descriptionItems: [5, 10, 15],
      vendors: [],
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      vendorList: (state) => state.vendorManagement.vendorList,
    }),
  },
  methods: {
    async getVendorList() {
      this.loading = true;
      try {
        await this.$store.dispatch("vendorManagement/setVendorList");
        this.vendors = this.vendorList;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    editVendor(id) {
      this.$router.push({ name: "Edit Vendor Management", params: { id: id } });
    },
    viewVendor(vendor) {
      this.$router.push({ name: "View Vendor Management", params: { id: vendor.id } });
    },
    async deleteVendor(id) {
      try {
        await this.$store.dispatch("inventory/deleteVendorAction", id);
        this.deleteUserDataPopup = false;
        this.getVendorList();
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Vendor Deleted Successfully!",
          type: "success",
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  created() {
    this.getVendorList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
</style>
